import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Dynamics = () => {
    return (
        <div className="otpBank-dynamic">
            <FullWrapper className="otpBank-dynamicCase">
                <div className="otpBank-dynamicWrapper">
                    <div className="otpBank-dynamicTitle">Создание новых страниц</div>
                    <div className="otpBank-dynamicText">
                        Первоначально мы&nbsp;оценили соответствие текста на&nbsp;страницах сайта
                        требованиям поисковых систем и&nbsp;запросам. Далее провели точечные работы
                        с&nbsp;контентом и&nbsp;регулярно прорабатываем семантическое ядро.
                    </div>
                    <div className="otpBank-dynamicText">
                        В&nbsp;процессе погружения в&nbsp;проект стратегия корректировалась
                        за&nbsp;счет новых идей и&nbsp;тестирования гипотез. Из&nbsp;удачных решений
                        стоит выделить работу с&nbsp;текстовыми факторами ранжирования, создание
                        новых посадочных страниц под региональные и&nbsp;узкоспециализированные
                        запросы. Также убрали канибализирующие друг друга страницы. Например, было
                        несколько страниц по&nbsp;теме &laquo;Кредит наличными&raquo;.
                    </div>

                    <div className="otpBank-dynamicBlock">
                        <div className="otpBank-dynamicDescription">
                            Динамика позиций сайта в&nbsp;поисковой системе Яндекс
                            (сентябрь&nbsp;&mdash; декабрь 2022)
                        </div>

                        <div className="otpBank-dynamicInner">
                            <div className="otpBank-dynamicHeader">
                                <div className="otpBank-dynamicSubtitle">
                                    количество запросов в топ-10
                                </div>
                                <div className="otpBank-dynamicNumber">×4</div>
                            </div>
                            <img
                                className="otpBank-dynamicGraphic"
                                src="/images/svg/otp-bank/dynamics-yandex.svg"
                                alt="dynamic-yandex"
                            />
                        </div>

                        <div className="otpBank-dynamicDescription">
                            Динамика позиций сайта в&nbsp;поисковой системе Google
                            (сентябрь&nbsp;&mdash; декабрь 2022)
                        </div>

                        <div className="otpBank-dynamicInner">
                            <div className="otpBank-dynamicHeader">
                                <div className="otpBank-dynamicSubtitle">
                                    количество запросов в топ-10
                                </div>
                                <div className="otpBank-dynamicNumber">×3,5</div>
                            </div>
                            <img
                                className="otpBank-dynamicGraphic"
                                src="/images/svg/otp-bank/dynamics-google.svg"
                                alt="dynamic-yandex"
                            />
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Dynamics;
